var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"disabled":_vm.busy,"variant":"link"},on:{"click":_vm.export_inventory}},[(!_vm.busy)?_c('font-awesome-icon',{attrs:{"icon":"fa-regular fa-upload"}}):_vm._e(),(_vm.busy)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_c('span',[_vm._v("Export CSV")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }